'use strict';

/**
 * Handles Razorpay modal dismissal by calling the cancellation API.
 *
 * @param {Object} data - Data to send in the POST request when payment is dismissed.
 * @param {string} dismissalUrl - API endpoint to handle Razorpay dismissal.
 * @param {string} razorpayredirecturl - URL to redirect the user after dismissal.
 */
function callDismissalHandler(data, dismissalUrl, razorpayredirecturl) {
    $.spinner().start();
    $.ajax({
        url: dismissalUrl,
        data: data,
        type: 'POST',
        success: function (datares) {
            $.spinner().stop();
            if (datares.error) {
                $('.error-message').show();
                $('.error-message-text').text(datares.errorMsg);
            }
            if (razorpayredirecturl) {
                window.location.href = razorpayredirecturl;
            }
        },
        error: function (error) {
            $.spinner().stop();
            $('.error-message').removeClass('d-none');
            $('.error-message').show(error);
        }
    });
}

module.exports = {
    callDismissalHandler: callDismissalHandler
};
